module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot4-ef79321e37a055d08c9651883d543100.png";